import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../../../../angular-material.module';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-comment',
  standalone: true,
  imports: [
    AngularMaterialModule,
    CommonModule,
    FormsModule,
    MatDialogModule,
  ],
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'], // Corrected from 'styleUrl' to 'styleUrls'
})
export class CommentComponent implements OnInit  {
  loading = false;
  submitting = false;
  newComment: string = '';
  issueId: number; // Declare the issueId property
  baseUrl = environment.baseUrl;
  allCommentList: any[] = [];
  userId = sessionStorage.getItem('session_id');
  storageUrl = environment.storageUrl;
    issuePhotoPreview: string | null = null;
  uploadedFileName: string | null = null;
    selectedFile: File | null = null;
    notifyCustomer: boolean = false;


  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<CommentComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { issueId: number }
  ) {
    this.issueId = data.issueId; // Initialize issueId with data passed to the dialog
  }

  ngOnInit(): void {
    if (this.issueId) {
      // Corrected from 'if{this.issueId}' to 'if (this.issueId)'
      this.fetchAllComments();
    }
  }


  fetchAllComments() {
    const payload = {
      account_id: sessionStorage.getItem('account_id'),
      issue_id: this.issueId, // Include issueId in the payload if needed
    };
    this.loading = true;
    this.http.post(`${this.baseUrl}/fetch_comments`, payload).subscribe({
      next: (res: any) => {
        this.allCommentList = res; // Assign response to allCommentList
      },
      error: (err: any) => {
        console.error('Error occurred:', err);
        this.snackBar.open('Error submitting request', 'Close', {
          duration: 3000,
        });
      },
      complete: () => {
        this.loading = false; // Hide progress bar once the API call completes
        console.log('Category dropdown fetch complete');
      }
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

onFileSelect(event: Event): void {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];

  if (file) {
    this.selectedFile = file;
    this.uploadedFileName = file.name;

    const reader = new FileReader();
    reader.onload = () => {
      this.issuePhotoPreview = reader.result as string;
    };
    reader.readAsDataURL(file);
  }
}

deleteFile(): void {
  this.selectedFile = null;
  this.issuePhotoPreview = null;
  this.uploadedFileName = null;
}

  // onAddComment() {
  //   const newCommentPayload = {
  //     account_id: sessionStorage.getItem('account_id'),
  //     issue_id: this.issueId,
  //     user_id: this.userId,
  //     comment: this.newComment,
  //     comment_image: null,
  //     is_notify_cust:'0'

  //   };

  //   this.http.post(`${this.baseUrl}/add_comment`, newCommentPayload).subscribe({
  //     next: (response) => {
  //       this.snackBar.open('Comment Added successfully!', 'Close', {
  //         duration: 3000,
  //       });
  //       this.fetchAllComments();
  //     },
  //     error: (err) => {
  //     },
  //     complete: () => {
  //     this.newComment=""
  //     },
  //   });
  // }

onAddComment() {
  // if (!this.newComment || !this.uploadedFileName) {
  //   this.snackBar.open('Please enter a comment or upload an image.', 'Close', { duration: 3000 });
  //   return;
  // }

  const formData = new FormData();
  formData.append('account_id', sessionStorage.getItem('account_id') || '');
  formData.append('issue_id', this.issueId.toString());
  formData.append('user_id', this.userId || '');
  formData.append('comment', this.newComment || '');
 formData.append('is_notify_cust', this.notifyCustomer ? '1' : '0');

  // If an image is selected, append it
  if (this.selectedFile) {
    formData.append('comment_image', this.selectedFile);
  }

  this.submitting = true;
  this.http.post(`${this.baseUrl}/add_comment`, formData).subscribe({
    next: () => {
      this.snackBar.open('Comment added successfully!', 'Close', { duration: 3000 });
      this.newComment = '';
      this.issuePhotoPreview = null;
      this.uploadedFileName = null;
      this.selectedFile = null;
      this.notifyCustomer = false;
      this.fetchAllComments();
    },
    error: (err) => {
      console.error('Error saving comment:', err);
      this.snackBar.open('Error saving comment. Try again.', 'Close', { duration: 3000 });
    },
    complete: () => {
      this.submitting = false;
    },
  });
}


/** Helper: Convert base64 dataURL to Blob for upload */
dataURLtoBlob(dataUrl: string): Blob {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new Blob([u8arr], { type: mime });
}

openImageDialog(imageUrl: string): void {
  this.dialog.open(ImageDialogComponent, {
    data: { imageUrl: imageUrl },
    maxWidth: '90vw',
    maxHeight: '90vh',
    panelClass: 'image-dialog-container'
  });
}

}

// Image Dialog Component
@Component({
  selector: 'app-image-dialog',
  template: `
    <div class="image-dialog">
      <button mat-icon-button class="close-button" (click)="close()" style="position: absolute; top: 8px; right: 8px; z-index: 1000;">
        <mat-icon>close</mat-icon>
      </button>
      <img [src]="data.imageUrl" alt="Full size image" style="max-width: 100%; max-height: 90vh; object-fit: contain;" />
    </div>
  `,
  styles: [`
    .image-dialog {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      background: rgba(0, 0, 0, 0.9);
    }
    .close-button {
      color: white;
      background: rgba(255, 255, 255, 0.2);
    }
    .close-button:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  `],
  standalone: true,
  imports: [AngularMaterialModule, CommonModule]
})
class ImageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
